import { Action, createReducer, on } from '@ngrx/store';
import { Reason } from '../../core/model/central/reason.model';
import { ReasonsSettingsActions } from './reasons-settings.actions';

export const STORE_FEATURE_KEY_REASONS = 'reasons';

export class ReasonsSettingsState {
    loadingIndicator: boolean;
    reasons: Array<Reason>;
    strategyId: number;
    selectedReason: Reason;
    revertChanges: boolean;
}

export const initializeReasonsSettingsState: ReasonsSettingsState = {
    reasons: [],
    loadingIndicator: false,
    strategyId: undefined,
    selectedReason: undefined,
    revertChanges: false
};

const reducer = createReducer(
    initializeReasonsSettingsState,
    on(ReasonsSettingsActions.getRemindersReasonsSuccess, (state, { payload }) =>
        ({ ...state,
           reasons: payload.reasons,
           loadingIndicator: true,
           revertChanges: false,
           selectedReason: payload.reasons !== undefined ? payload.reasons[0] : undefined
        })),
    on(ReasonsSettingsActions.saveRemindersReasonsSuccess, (state, { payload }) =>
        ({ ...state,
           loadingIndicator: true,
           revertChanges: false
        })),
    on(ReasonsSettingsActions.saveRemindersReasons, (state,  payload) =>
        ({ ...state,
           loadingIndicator: false,
           revertChanges: false
        })),
    on(ReasonsSettingsActions.openConfirmDialogCancel, (state,  payload) =>
        ({ ...state,
           loadingIndicator: true,
           revertChanges: true
        }))
);

export function ReasonsSettingsReducer(state: ReasonsSettingsState | undefined, action: Action) {
    return reducer(state, action);
}
